import { FilterOutlined } from '@ant-design/icons';
import { Button, Tag } from 'antd';
import { FC, useState } from 'react';
import { CHIPS_SECUNDARIO, CHIPS_TIPO, CHIPS_VENCIDO, FilterChip } from '../../model/capabilities';

const { CheckableTag } = Tag;

interface IProps {
	selected: string[];
	facets?: Record<string, number>;
	on_toggle: (token: string) => void;
	on_clear: () => void;
}

export const CapabilityFilterBar: FC<IProps> = ({ selected, facets, on_toggle, on_clear }) => {
	const [show_more, set_show_more] = useState(false);

	const render_chip = (chip: FilterChip) => {
		const count = facets ? facets[chip.token] : undefined;
		const label = count !== undefined ? `${chip.label} (${count})` : chip.label;
		const checked = selected.includes(chip.token);

		return (
			<CheckableTag
				key={chip.token}
				checked={checked}
				onChange={() => on_toggle(chip.token)}
				style={{
					padding: '4px 12px',
					marginBottom: 6,
					borderRadius: 4,
					border: `1px solid ${checked ? chip.color : '#d9d9d9'}`,
					background: checked ? chip.color : '#fff',
					color: checked ? '#fff' : chip.color,
					fontWeight: checked ? 600 : 400,
				}}
			>
				{label}
			</CheckableTag>
		);
	};

	const divider = <span style={{ width: 1, height: 20, background: '#eee', margin: '0 8px' }} />;

	return (
		<div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: 4 }}>
			<span style={{ color: '#888', marginRight: 8 }}>
				<FilterOutlined /> Filtros:
			</span>

			{CHIPS_TIPO.map(render_chip)}
			{divider}
			{CHIPS_VENCIDO.map(render_chip)}

			{show_more && (
				<>
					{divider}
					{CHIPS_SECUNDARIO.map(render_chip)}
				</>
			)}

			<Button type='link' size='small' onClick={() => set_show_more(!show_more)}>
				{show_more ? 'Menos filtros' : 'Mais filtros'}
			</Button>

			{selected.length > 0 && (
				<Button type='link' size='small' danger onClick={on_clear}>
					Limpar filtros
				</Button>
			)}
		</div>
	);
};
